<template>
  <div class="row">
    <section class="text-center button-bar">
      <slot v-if="isRetryable" />
      <button v-if="isValidRefUrl" type="button" class="btn btn-default offset-left-1 offset-right-1" @click="onRedirect">
        {{ $t('common.back') }}
      </button>
    </section>
  </div>
</template>

<script>
import { ERROR_RETRY_CODE } from '@route-types';
import { isSafeNavigationUrl, safeNavigate } from '@/utils/safeUrl';

export default {
  name: 'ErrorBackToRefUrl',

  props: {
    refUrl: {
      type: String,
      required: false,
      default: '',
    },
    redirectTime: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  computed: {
    code() {
      return this.$route.params.code;
    },
    isRetryable() {
      return this.$route.name === ERROR_RETRY_CODE;
    },
    // SECURITY: Allowlist URL schemes (http/https) — `new URL()` alone accepts
    // `javascript:` / `data:` URIs and would enable DOM-based XSS when later
    // assigned to `window.location.href`.
    isValidRefUrl() {
      return isSafeNavigationUrl(this.refUrl);
    },
  },

  created() {
    if (this.redirectTime && this.isValidRefUrl) {
      setTimeout(() => {
        this.onRedirect();
      }, this.redirectTime * 1000);
    }
  },

  methods: {
    onRedirect() {
      // SECURITY: safeNavigate refuses non-http(s) URLs.
      safeNavigate(this.refUrl);
    },
  },
};
</script>
